import { Inject, Injectable } from '@angular/core';
import * as signalR from "@microsoft/signalr";
import { GlobalState } from '../../../../app.state';
import { AuthService } from '../../authentication/auth.service';
import { HubInAppNotificationMessage } from './pcode-users.hub.models';

@Injectable({
	providedIn: 'root'
})
export class PCodeUsersHub
{
	// variables
	private hubConnection: signalR.HubConnection

	// constructor
	constructor
		(
			@Inject('BASE_URL') private baseUrl: string,
			private state: GlobalState
		)
	{

	}

	// start connection
	public startConnection = () =>
	{
		// hub connection
		this.hubConnection = new signalR.HubConnectionBuilder()
			.withUrl(`${this.baseUrl}hub/pcodeusers`, { accessTokenFactory: () => AuthService.getAccessToken() })
			.build();

		// start connection
		this.hubConnection
			.start()
			.then(() =>
			{
				// register logged user
				this.register();

				// register in-app notifications listener
				this.inAppNotificationsListener();
			})
			.catch(err => console.log('Error while starting connection: ' + err))
	}

	// register logged user
	public register = () =>
	{
		if (this.hubConnection)
			this.hubConnection.invoke('register');
	}

	// disconnect user
	public disconnect = () =>
	{
		if (this.hubConnection)
			this.hubConnection.invoke('disconnect');
	}

	// register in-app notifications listener
	public inAppNotificationsListener = () =>
	{
		this.hubConnection.on('updateInAppNotificationsCount', (data: HubInAppNotificationMessage) =>
		{
			this.state.notifyDataChanged("app.userNotifications", data.count);
		});
	}
}